import $ from "jquery";
import tt from '@tomtom-international/web-sdk-maps';
import moment from 'moment';
import Stomp from 'stompjs';

const stompServices = {
  stompClient: null,

  connect(path,callback) {
    const socket = new WebSocket(`ws://${process.env.WEB_SOCKET}${path}`);
    this.stompClient = Stomp.over(socket);
    this.stompClient.connect({}, (frame) => {
      let data = {
        status: frame.command
      }
      callback(data);
    });
  },

  subscribe(destination,callback) {
    this.stompClient.subscribe(destination, (message) => {
      callback(message.body);
    })
  },
  send(destination, message) {
    this.stompClient.send(destination, {}, message);
  },

  disconnect() {
    if (this.stompClient) {
      this.stompClient.disconnect(() => {
        console.log('Putuskan');
      });
    }
  },
};

export default {
   /**
    * @return {boolean}
    */
   ResponseCode(data) {
      if (data.data.code === "00") {
        return true;
      }
      return false;
   },
   ResponseCode02(data) {
      if (data.code === "00") {
        return true;
      }
      return false;
   },
   /**
    * @return {boolean}
    */
   ResponseStatus(data) {
      if (data.status === 200) {
        return true;
      }
      return false;
   },
   isEmpty(data) {
      if (data === undefined || data === null) {
        return false;
      }
      return true;
   },
   GetGeoCoder(data,search) {
      let toObj       =       this.ObjToParams(data);
      // let result      =       [];
      return new Promise((resolve) => {
          $.ajax({
              type: "GET",
              url:  "https://api.tomtom.com/search/2/geocode/"+search+".json?"+toObj,
          })
          .done(function(data) {
              // window.console.log(data);
              resolve(data);
          });
      });
      // return result[0];
  },
  ObjToParams(obj) {
   var str = "";
   for (var key in obj) {
       if (str != "") {
           str += "&";
       }
       str += key + "=" + encodeURIComponent(obj[key]);
   }
   return str;
   },
   ResultSearchMaps(data) {
      // window.console.log(data.results[0]);
      var map = tt.map({
          key: '4J7FBBrUwuEkmdkGQg2V5KvbWrueQfip',
          container: 'map',
          center: {
              lat:  data.results[0].position.lat,
              lon:  data.results[0].position.lon
          },
          zoom: 7
      });
      map.addControl(new tt.FullscreenControl());
      map.addControl(new tt.NavigationControl());
      function createMarker(position, color, popupText) {
          var markerElement = document.createElement('div');
          markerElement.className = 'marker';
          var markerContentElement = document.createElement('div');
          markerContentElement.className = 'marker-content';
          // markerContentElement.style.backgroundColor = color;
          markerElement.appendChild(markerContentElement);
          var iconElement = document.createElement('div');
         iconElement.className    = 'images custom-map-marker';
         iconElement.style.backgroundImage = 'url(https://img.icons8.com/office/40/000000/map-pin.png)';
          // iconElement.style.backgroundImage =
          //     'url(https://api.tomtom.com/maps-sdk-for-web/cdn/static/' + icon + ')';
          markerContentElement.appendChild(iconElement);
          var popup  = new tt.Popup({offset: 30}).setText(popupText);
          // add marker to map
          let marker = new tt.Marker({draggable: true,element: markerElement, anchor: 'bottom'})
              .setLngLat(position)
              .setPopup(popup)
              .addTo(map);
          popup.on('open', function() {
            //   $('#long').html(popup.getLngLat().lng);
            //   $('#lat').html(popup.getLngLat().lat);
              $('#longInput').val(popup.getLngLat().lng);
              $('#latInput').val(popup.getLngLat().lat);
          });
          marker.on('drag', function() {
              // window.console.log(marker.getLngLat());
            //   $('#long').html(marker.getLngLat().lng);
            //   $('#lat').html(marker.getLngLat().lat);
              $('#longInput').val(marker.getLngLat().lng);
              $('#latInput').val(marker.getLngLat().lat);
          });
      }
      for (let i = 0; i < data.results.length; i++) {
          let position        =     {
              lat:      data.results[i].position.lat,
              lon:      data.results[i].position.lon
          };
          createMarker(position, '',data.results[i].address.freeformAddress);
      }
  },
  FormatDate(time) {
    moment.locale('id');
    let date = moment(time, "YYYY/MM/DD").format("DD MMMM, YYYY");

    return date;
  },
  /**
   * @return {string}
   */
  TimeStampToDate(time) {
    var timestamp = time;
    var date = new Date(timestamp);
    var formattedDate = date.toLocaleString();
    // window.console.log(formattedDate);
    return moment(formattedDate).format("YYYY-MM-DD");
  },
  FormatYearMonth(time) {
     let month =  moment(time).format("MM");
     let year  =  moment(time).format("YYYY");
     return {
       year: year,
       month: month
     }
  },
  FormatYMD(time) {
    return moment(time).format("YYYY-MM-DD");
  },
  getPayload(data) {
    const form = new FormData();
    for (const key in data) {
      if (
        data.hasOwnProperty(key) &&
        data[key] != null
      ) {
        form.append(key, data[key]);
      }
    }
    return form;
  },
  isNumeric(str) {
    return Number.isInteger(str);
  },
  /**
   * @return {string}
   */
  FormatCurrency(data) {
    let text;
    if (this.isNumeric(data)) {
      text  =  data.toString();
    }
    let res      =      text.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return res;
  },
  /**
   * @return {number}
   */
  RemovePointToInt(string) {
    let remove = string.replaceAll('.','');
    return parseInt(remove);
  },
  WebSocketConnection(data,callback) {
    stompServices.connect('/connect-websocket-payslip',(eventConnect) => {
      // window.console.log(event);
      if (eventConnect.status === "CONNECTED") {
        let req = {
          payslipId: parseInt(data.payslipId)
        }
        stompServices.send('/payslip/get-by-payslip-id', JSON.stringify(req));
        stompServices.subscribe('/websocket-payslip/get-by-payslip-id', (event) => {
          let result = {
            data: JSON.parse(event),
            status: eventConnect.status
          };
          callback(result);
        });
      }
    });
  },
  removeAlphabeticCharacters(inputString) {
    // Use a regular expression to match and remove all alphabetic characters
    return inputString.replace(/[a-zA-Z]/g, '');
  },
  isNumber: function(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  },
  RemovePoint(number) {
    try {
      let remove       = number.split('.').join("").replace('Rp ', '');
      let removeComma  = this.RemoveComma(remove);
      return removeComma;
    } catch (error) {
      // (error);
      return error;
    }
  },
};
